import { LayoutTemplateContentContainer } from '../app/AppViewComponent.styles';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { OAuthSignupSection } from '../oauth/OAuthSignupSection';
import { Data } from 'signup-constants/signupData/Data';
import { SignupDataInputForm } from '../signup-data/SignupDataInputForm';
import { Step } from 'signup-constants/Step';
import { getLandingPageButton } from './getLandingPageText';
import { useLandingPage } from './useLandingPage';
import styled from 'styled-components';
import VerticalSeparator from './VerticalSeparator';
import { useSelector } from 'react-redux';
import { getShouldShowTooltip } from '../store/signup-data/selectors';
import { useSignupData } from '../signup-data/useSignupData';
import PrivacyBanner from '../views-components/PrivacyBanner';
import CreateAccountTermsOfService from '../views-components/CreateAccountTermsOfService';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { devices } from 'signup-constants/styles/viewports.styles';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import Separator from './Separator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SeparatorContainer = styled.div.withConfig({
  displayName: "WideLandingPage__SeparatorContainer",
  componentId: "sc-1egifkg-0"
})(["max-width:420px;"]);
const Container = styled.div.withConfig({
  displayName: "WideLandingPage__Container",
  componentId: "sc-1egifkg-1"
})(["margin-top:16px;max-width:1200px;margin-left:auto;margin-right:auto;@media ", "{margin-top:32px;height:200px;display:flex;}"], devices.desktop);
const OAuthContainer = styled.div.withConfig({
  displayName: "WideLandingPage__OAuthContainer",
  componentId: "sc-1egifkg-2"
})(["margin-right:auto;width:100%;max-width:420px;@media ", "{width:49%;max-width:none;}"], devices.desktop);
const EmailContainer = styled.div.withConfig({
  displayName: "WideLandingPage__EmailContainer",
  componentId: "sc-1egifkg-3"
})(["width:100%;margin-top:20px;@media ", "{margin-top:0;display:flex;width:49%;}"], devices.desktop);
const EmailFieldContainer = styled.div.withConfig({
  displayName: "WideLandingPage__EmailFieldContainer",
  componentId: "sc-1egifkg-4"
})(["max-width:420px;margin-right:auto;width:100%;@media ", "{max-width:420px;margin:inherit;margin-left:auto;}"], devices.desktop);
const CenteredContainer = styled.div.withConfig({
  displayName: "WideLandingPage__CenteredContainer",
  componentId: "sc-1egifkg-5"
})(["text-align:center;width:420px;@media ", "{margin:40px 140px 0 140px;width:auto;}"], devices.desktop);
const WideLandingPageView = () => {
  const stepKey = Step.LandingPage;
  const {
    chooseEmailSignUp
  } = useLandingPage(stepKey);
  const {
    layoutType
  } = useLayoutTemplate();
  const {
    isValid
  } = useSignupData(Data.Email);
  const shouldShowTooltip = useSelector(state => getShouldShowTooltip(state, Data.Email));
  const {
    shouldShowTosOnLandingPage: shouldShowTermsOfService
  } = getFlowConfig();
  const {
    isDesktop
  } = useResponsiveness();
  return /*#__PURE__*/_jsxs(LayoutTemplateContentContainer
  // @ts-expect-error Expression produces a union type that is too complex to represent.
  , {
    layoutType: layoutType,
    shouldRestrictWidth: true,
    stepKey: Step.LandingPage,
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(OAuthContainer, {
        children: /*#__PURE__*/_jsx(OAuthSignupSection, {
          shouldShowSeperator: false
        })
      }), isDesktop ? /*#__PURE__*/_jsx(VerticalSeparator, {
        message: `views.${Step.LandingPage}.separator`
      }) : /*#__PURE__*/_jsx(SeparatorContainer, {
        children: /*#__PURE__*/_jsx(Separator, {
          message: `views.${Step.LandingPage}.separator`
        })
      }), /*#__PURE__*/_jsx(EmailContainer, {
        children: /*#__PURE__*/_jsx(EmailFieldContainer, {
          children: /*#__PURE__*/_jsx(SignupDataInputForm, {
            autoFocus: false,
            buttonProps: {
              label: getLandingPageButton()
            },
            dataKey: Data.Email,
            inputHeight: '140px',
            inputMode: 'email',
            isACQ0143Variant: true,
            shouldShowTooltip: shouldShowTooltip && isValid,
            shouldTrimData: true,
            submit: chooseEmailSignUp,
            tooltipWidth: '420px'
          }, Data.Email)
        })
      })]
    }), /*#__PURE__*/_jsxs(CenteredContainer, {
      children: [/*#__PURE__*/_jsx(PrivacyBanner, {}), shouldShowTermsOfService && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {})]
    })]
  });
};
export default WideLandingPageView;